// extracted by extract-css-chunks-webpack-plugin
module.exports = {"note":"tasks-award-leader-note__note--2t-qp","note-title":"tasks-award-leader-note__note-title--1TopZ","noteTitle":"tasks-award-leader-note__note-title--1TopZ"};